import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { CoachService } from './coach.service';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService {

  constructor(
    private injector: Injector,
  ) { }

  intercept(req: any, next: any): Observable<any> {
    let authService = this.injector.get(AuthService);
    let coachService = this.injector.get(CoachService);
    let tokenizedReq = req.clone({
      setHeaders: {
        'x-access-token': `${authService.getToken()}`,
        'selected-sport-level': `${coachService.getSelectedSportlevel()}`,
        ...(authService?.getCoachSessionDetails()?.user_type === 'athletic_director' && {
          'selected-coach': coachService.getCoach()
        }),


      }
    })

    return next.handle(tokenizedReq);
  }
}
